const reISO = /^(\d{4})-(\d{2})-(\d{2})$/;

export function filterByValue<T>(data: T[] | undefined, searchValue: string) {
	// Dont initiate search until we have enough to use
	if (
		data &&
		typeof data === 'object' &&
		data.length > 0 &&
		searchValue.length >= 3
	) {
		return data.filter((obj) => {
			if (obj && typeof obj === 'object') {
				Object.keys(obj).some((key) => {
					const searchableObj = obj as Record<string, unknown>;
					let searchableValue;
					if (typeof searchableObj[key] === 'string') {
						if (reISO.exec(searchableObj[key])) {
							// Key was a date
							searchableValue = new Date(
								searchableObj[key] + '00:00:00'
							).toLocaleDateString('en-US');
						} else {
							searchableValue = searchableObj[key];
						}
					} else {
						// Cast as string
						searchableValue = String(searchableObj[key]);
					}

					return searchableValue
						.toLowerCase()
						.includes(searchValue.toLowerCase());
				});
			}

			return obj;
		});
	}

	return data;
}
